import { render, staticRenderFns } from "./QnrIntroGetStarted.vue?vue&type=template&id=baef3548&scoped=true&"
import script from "./QnrIntroGetStarted.vue?vue&type=script&lang=js&"
export * from "./QnrIntroGetStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baef3548",
  null
  
)

export default component.exports